import httpService from "../../components/service";
import campaignService from "@/services/campaign";

export const list = {
    namespaced: true,
    state: {
        campaigns: []
    },
    getters: {},
    mutations: {
        SET_LIST_CAMPAIGN(state, campaigns) {
            state.campaigns = campaigns;
        },
        UPDATE_LIST_CAMPAIGN(state, newCampaign) {
            let index = state.campaigns.findIndex(camp => camp.id === newCampaign.id);
            state.campaigns[index] = newCampaign;
        },
        DELETE_CAMPAIGN_IN_LIST(state, id) {
            state.campaigns = state.campaigns.filter(campaign => campaign.id !== id);
        }
    },
    actions: {
        async populateCampaignsList(context, type = undefined) {
            const res = await httpService.get("/admin/campaigns/list?limit=100");
            if (res.code) throw Error(res.message);
            context.commit("SET_LIST_CAMPAIGN", res.data);
            return res;
        },

        async updateCampaign({ commit }, { id, campaign }) {
            const res = await campaignService.update({ id, campaign });
            if (res.code) throw Error(res.message);
            commit("UPDATE_LIST_CAMPAIGN", res);
            return res;
        },
        async deleteCampaign({ commit }, id) {
            const res = await campaignService.deleteCampaign(id);
            if (res.code) throw Error(res.message);
            commit("DELETE_CAMPAIGN_IN_LIST", id);
            return res;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/campaign/list.js